// extracted by mini-css-extract-plugin
module.exports = {"root":"Paper_root__1A4Nw","page":"Paper_page__n7f9_","sticker":"Paper_sticker__j1xPS","show":"Paper_show__3L6Sy"};